module.exports = __webpack_public_path__ + "img/osadchiy.4476e092.png";